import './AppAccordion.scss';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { isValidElement } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from 'react';

interface Props {
  details: any;
  summary: any;
  expanded?: boolean;
  onChange?: (isExpanded: boolean) => void;
}

const AppAccordion = ({ details, summary, expanded, onChange }: Props) => {

  const renderContent = (content: any) => {
    if (Array.isArray(content)) {
      return content.map((item, index) =>
        isValidElement(item) ? (
          <div key={index}>{item}</div>
        ) : (
          <div key={index} dangerouslySetInnerHTML={{ __html: item }} />
        )
      );
    }

    if (isValidElement(content)) {
      return content;
    }

    return <div dangerouslySetInnerHTML={{ __html: content }} />;
  };

  React.useEffect(() => {
    const container = document.querySelectorAll('.code-snippet-buttons');
    container.forEach((element: Element) => {
      element.addEventListener('click', () => {
        handleCopy(element, element.getAttribute('data-code') || '');
      });
    });

    return () => {
      container.forEach((element: Element) => {
        element.removeEventListener('click', () => {
          handleCopy(element, element.getAttribute('data-code') || '');
        });
      });
    };
  }, []);

  const handleCopy = (element, data) => {
    element.innerText = 'Copied!';
    navigator.clipboard
      .writeText(data)
      .then(() => {
        setTimeout(() => {
          element.innerText = 'Copy';
        }, 2000);
      })
      .catch((err) => {
        console.log('Failed to copy: ', err);
      });
  };

  const addAriaLabelToElement = (htmlContent, data) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const elements = doc.querySelectorAll('a');
    elements.forEach((element) => {
      element.setAttribute('aria-label', `${data.trim()}`); // Add aria-label
    });
    return doc.body.innerHTML;
  };

  return (
    <Accordion className="app-accordion"
    expanded={expanded}
    onChange= {(event, isExpanded) => onChange?.(isExpanded)}>
      <AccordionSummary
        aria-controls="panel-content"
        className="accordion-summary"
        expandIcon={<ExpandMoreIcon className="icon-expand-more" />}
        id="panel-header"
      >
        {renderContent(summary)}
      </AccordionSummary>
      <AccordionDetails className="accordion-details">
        {renderContent(addAriaLabelToElement(details, summary))}{' '}
      </AccordionDetails>
    </Accordion>
  );
};

export default AppAccordion;
